(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["index"] && !Shopify.designMode) return;
  try {
    
let conceptImgAfterTimeout = null; // 関数外で宣言

document.addEventListener('DOMContentLoaded', function() {

  //------------------------------
  // FV スライドショー
  //------------------------------
  const swiper = new Swiper('.js-hero_slider', {
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    loop: true,
    speed: 2000
    // on: {
    //   init: function() {
    //     const swiperEl = this.el;
    //     swiperEl.addEventListener('mouseenter', () => {
    //       this.autoplay.stop();
    //     });
    //     swiperEl.addEventListener('mouseleave', () => {
    //       this.autoplay.start();
    //     });
    //   }
    // }
  });

  //------------------------------
  // CONCEPT アニメーション
  //------------------------------

  const conceptImg = document.querySelector('.concept_img');
  const conceptTitleWrapper = document.querySelector('.concept_title');
  const conceptTitle = document.querySelector('.concept_title span');
  const conceptImgAfter = document.querySelector('.concept_img_after');
  let conceptLine = document.querySelector('.concept_img_line');

  if (!conceptLine) {
    conceptLine = document.createElement('div');
    conceptLine.classList.add('concept_img_line');
    conceptImg.appendChild(conceptLine);
  }

  function isMobile() {
    return window.innerWidth < 900;
  }

  function updateImageSize() {
    const conceptImgHeight = conceptImg.offsetHeight;
    const conceptImgRect = conceptImg.getBoundingClientRect();
    const conceptImgTop = conceptImgRect.top;
    const conceptTitleRect = conceptTitleWrapper.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const mobile = isMobile();

    const startPoint = mobile ? windowHeight * 0.5 : windowHeight * 0.7;
    const endPoint = 0;
    const totalDistance = startPoint - endPoint;
    const initialWidth = mobile ? 56.53 : 61.9269747;
    const maxWidth = 100;

    // タイトルのY移動
    let translateY = 120;
    let translateX = 0; // X軸移動を追加

    if (conceptImgTop > startPoint) {
      const titleDistance = windowHeight - conceptTitleRect.top;
      const maxDistance = windowHeight;
      let yProgress = Math.min(Math.max(titleDistance / maxDistance, 0), 1);
      translateY = 120 - 120 * yProgress;
    } else {
      translateY = 0;
      const progressRatio = Math.min(Math.max((startPoint - conceptImgTop) / totalDistance, 0), 1);
      const currentWidth = initialWidth + (maxWidth - initialWidth) * progressRatio;
      conceptImg.style.width = `${currentWidth}vw`;
    }

    // タイトルのtransform適用（Y移動のみ、X移動は後で追加）
    conceptTitleWrapper.style.transform = `translateY(${translateY}px) translateX(${translateX}px)`;

    // 線の伸縮（モバイル・PC別設定）
    const baseHeight = conceptImgHeight - 70;
    const maxHeight = conceptImgHeight * (mobile ? 1.5 : 2.57);

    // ライン伸縮のトリガー計算（タイトル移動と同じタイミング）
    let lineProgress;
    if (conceptImgTop > startPoint) {
      const titleDistance = windowHeight - conceptTitleRect.top;
      const maxDistance = windowHeight;
      lineProgress = Math.min(Math.max(titleDistance / maxDistance, 0), 1);
    } else {
      lineProgress = 1;
    }

    const currentLineHeight = baseHeight + (maxHeight - baseHeight) * lineProgress;
    conceptLine.style.height = `${currentLineHeight}px`;

    // expand判定
    const isSticky = conceptImgTop <= 1;
    if (isSticky) {
      conceptImgAfter.classList.add('expand');
    } else {
      conceptImgAfter.classList.remove('expand');
    }

    // 画像拡大とタイトル色、X軸移動
    if (conceptImgTop <= startPoint && conceptImgTop >= endPoint) {
      const currentProgress = startPoint - conceptImgTop;
      const progressRatio = Math.min(Math.max(currentProgress / totalDistance, 0), 1);
      const currentWidth = initialWidth + (maxWidth - initialWidth) * progressRatio;
      conceptImg.style.width = `${currentWidth}vw`;

      // タイトルのX軸移動（画像拡大と同じタイミング）
      translateX = 20 * progressRatio; // 最大20px右移動
      conceptTitleWrapper.style.transform = `translateY(${translateY}px) translateX(${translateX}px)`;

      const colorChangePoint = mobile ? windowHeight * 0.2 : windowHeight * 0.1;
      conceptTitle.style.color = conceptImgTop <= colorChangePoint ? '#fff' : '#1A1A1A';
    } else if (conceptImgTop < endPoint) {
      conceptImg.style.width = `${maxWidth}vw`;
      translateX = 20; // 完全に右移動
      conceptTitleWrapper.style.transform = `translateY(${translateY}px) translateX(${translateX}px)`;
      conceptTitle.style.color = '#fff';
    } else {
      conceptImg.style.width = `${initialWidth}vw`;
      translateX = 0; // 初期位置
      conceptTitleWrapper.style.transform = `translateY(${translateY}px) translateX(${translateX}px)`;
      conceptTitle.style.color = '#1A1A1A';
    }
  }

  window.addEventListener('scroll', updateImageSize);
  window.addEventListener('resize', updateImageSize);
  updateImageSize();

  //concept_section内画像上英字文章のパララックス
  const enText = document.querySelector('.concept_text_en');
  let active = false;
  let startY = null;

  const observer_concept = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        active = true;
        if (startY === null) {
          startY = window.scrollY;
        }
      } else {
        active = false;
      }
    });
  }, { threshold: 0.1 });

  observer_concept.observe(enText);

  window.addEventListener('scroll', () => {
    if (!active || startY === null) return;

    const diff = window.scrollY - startY;
    const mobile = isMobile();
    const parallaxSpeed = mobile ? -0.3 : -0.15;
    const currentTransform = diff * parallaxSpeed;
    enText.style.transform = `translateY(${currentTransform}px)`;
  });

  //concept_sectionのフェードアウト(スクロール量に応じて)
  const conceptSection = document.querySelector('.concept_section');

  window.addEventListener('scroll', () => {
    const rect = conceptSection.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    const distance = windowHeight - rect.bottom - 100;

    if (distance > 0) {
      let opacity = 1 - distance / 600; // 300pxスクロールで完全に消える
      opacity = Math.max(0, Math.min(1, opacity));
      conceptSection.style.opacity = opacity;
    } else {
      conceptSection.style.opacity = 1;
    }
  });

  //------------------------------
  // イメージビジュアルのfade
  //------------------------------
  const targets = document.querySelectorAll('.photo');
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.2
  });
  targets.forEach(target => {
    observer.observe(target);
  });

  //------------------------------
  // 左右のロゴのアニメーション
  //------------------------------
  const applyParallax = (selector, speedFactor) => {
    const element = document.querySelector(selector);
    if (!element) return;

    const section = element.closest('.photos_section');
    if (!section) return;

    let elementStartOffset = 0;

    const recalculateOffset = () => {
      elementStartOffset = section.offsetTop + element.offsetTop;
    };

    window.addEventListener('load', recalculateOffset);
    window.addEventListener('resize', recalculateOffset);
    recalculateOffset();

    const parallaxEffect = () => {
      const scrollY = window.scrollY;

      if (scrollY >= elementStartOffset) {
        const distance = scrollY - elementStartOffset;
        element.style.transform = `translateY(${distance * speedFactor}px)`;
      } else {
        element.style.transform = 'translateY(0px)';
      }
    };

    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          parallaxEffect();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  };

  applyParallax('.photo_logo_left', 0.5);
  applyParallax('.photo_logo_right', 0.3);

  //------------------------------
  // Productsの画像fixed (PCのみ)
  //------------------------------
  function handleProductsImgFixed() {
    if (window.innerWidth < 900) {
      const img = document.querySelector('.products_img');
      if (img) img.classList.remove('is-fixed');
      return;
    }
    const section = document.querySelector('.products_section');
    const img = document.querySelector('.products_img.pc-only');
    if (!section || !img) return;
    const sectionRect = section.getBoundingClientRect();
    const sectionTop = sectionRect.top + window.scrollY;
    if (window.scrollY >= sectionTop) {
      img.classList.add('is-fixed');
    } else {
      img.classList.remove('is-fixed');
    }
    // 画像の下がセクションの下を越えたらfixed解除して画像は下配置に
    const sectionBottom = sectionTop + section.offsetHeight;
    const imgRect = img.getBoundingClientRect();
    const imgBottom = imgRect.bottom + window.scrollY;
    if (imgBottom > sectionBottom) {
      img.classList.remove('is-fixed');
      if (window.scrollY >= sectionTop) {
        img.style.display = 'flex';
        img.style.alignItems = 'flex-end';
      } else {
        img.style.display = '';
        img.style.alignItems = '';
      }
    } else {
      img.style.display = '';
      img.style.alignItems = '';
    }
  }
  window.addEventListener('scroll', handleProductsImgFixed, { passive: true });
  window.addEventListener('resize', handleProductsImgFixed);
  handleProductsImgFixed();
});

  } catch(e) { console.error(e); }
})();
})();
